import React, { useState, useEffect, useRef } from 'react';
import { Form, Input } from 'antd';
import PictureInput from '../../components/media/PictureInput';
import AudioInput from '../../components/media/AudioInput';

const MeditationItem: React.FC<any> = ({ form, prefix, fullPrefix }) => {
  const [isVisible, setIsVisible] = useState(false);
  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // 一旦可见就停止观察
        }
      },
      {
        rootMargin: '100px' // 提前100px开始加载
      }
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={itemRef}>
      <Form.Item
        name={[...prefix, 'title']}
        label={`名称`}
        rules={[{ required: true, message: '不能为空' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={[...prefix, 'type']}
        label={`类型`}
        rules={[{ required: true, message: '不能为空' }]}
      >
        <Input />
      </Form.Item>
      {/* 只有当组件可见时才渲染媒体输入组件 */}
      {isVisible && (
        <>
          <PictureInput form={form} prefix={prefix} fullPrefix={fullPrefix} />
          <AudioInput form={form} prefix={prefix} fullPrefix={fullPrefix} />
        </>
      )}
    </div>
  );
};

export default MeditationItem;